<script setup lang="ts">
import { SwitchThumb, SwitchRoot } from 'radix-vue'
import { defineModel } from '#imports'

interface Props {
  id: string
  disabled?: boolean
  reverse?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  reverse: false,
  isSecondary: false,
})

const modelValue = defineModel<boolean>()
</script>

<template>
  <div
    class="flex justify-between gap-2"
    :class="{ 'flex-row-reverse': reverse }"
  >
    <SwitchRoot
      :id="id"
      v-model:checked="modelValue"
      :disabled="disabled"
      :class="{
        'border-gray-300 bg-white': !disabled && !modelValue,
        'border-gray-900 bg-gray-900': !disabled && modelValue,
        'border-gray-200 bg-gray-100': disabled && !modelValue,
        'border-gray-300 bg-gray-200': disabled && modelValue,
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled,
      }"
      class="w-12 h-6 box-border border outline-none focus-within:ring focus-within:ring-peacock-300 focus-within:ring-offset-2 flex rounded-full relative "
    >
      <SwitchThumb
        :class="{
          'bg-gray-300': (!disabled && !modelValue) || (disabled && modelValue),
          'bg-white': !disabled && modelValue,
          'bg-gray-200': disabled && !modelValue,
        }"
        class="block w-4 h-4 my-auto bg-gray-300 rounded-full transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[1.75rem]"
      />
    </SwitchRoot>
    <div
      v-if="$slots.default || $slots.description"
      :id="id"
    >
      <label
        :class="{ 'cursor-not-allowed': disabled, 'cursor-pointer': !disabled }"
        :for="id"
      >
        <slot />
      </label>
      <p
        v-if="$slots.description"
        class="text-sm"
        :class="{ 'text-gray-500': !disabled }"
      >
        <slot name="description" />
      </p>
    </div>
  </div>
</template>
